import { DOCUMENT } from '@angular/common';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Component, ElementRef, HostListener, inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { DomSanitizer } from '@angular/platform-browser';
import { animate, style, transition, trigger } from '@angular/animations';
import { SyncService } from '../sync.service';
import { NotificationType } from 'carbon-components-angular/notification/notification-content.interface';
import { HttpService } from '../http.service';

@Component({
	selector: 'multiplai',
	templateUrl: './multiplai.component.html',
	styleUrls: ['./multiplai.component.scss'],
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('125ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0}))
			])
		]),
		trigger('fadeInUp', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(-2px)' }),
				animate('125ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0, transform: 'translateY(2px)' }))
			])
		])
	]
})

export class MultiplaiComponent implements OnInit {

	hoveringOverItem = '';

	email = '';

	showAnalyzingNotification = false;
	showSuccessNotification = false;
	showErrorNotification = false;
	showValueNotFoundNotification = false;
	dealToDelete: any = {};
	deleteDealModalOpen = false;

	selectedDealName: any = '';
	selectedFileName: any = '';

	authStatus = 'unauthenticated';
	rightSideOpen = false;
	theme = 'g100';

	page = 'funds';
	userData: any = null;

	deals: any[] = [];
	displayDeals: any[] = [];
	displayFiles: any[] = [];
	document = inject(DOCUMENT);
	renderer = inject(Renderer2);

	pdfSrc = '';

	safePdfSrc: any;

	selectedFiles: any[] = [];

	dealsDocRef: string | undefined;
	showSpinner = false;

	showNotification = false;
	notificationType: NotificationType = 'success';
	notificationTitle = '';
	notificationSubtitle = '';
	workspace = '';

	@ViewChild('panel') panel: ElementRef | undefined;
	constructor(
		private afStore: AngularFirestore,
		private sanitizer: DomSanitizer,
		public syncService: SyncService,
		private httpService: HttpService,
	) {}

	ngOnInit(): void {

		this.syncService.email$.subscribe((data) => {
			this.email = data;
		});

		this.syncService.workspace$.subscribe((data) => {
			this.workspace = data;
		});

		this.syncService.showNotification$.subscribe((data) => {
			this.showNotification = data;
		});

		this.syncService.notificationType$.subscribe((data) => {
			this.notificationType = data;
		});

		this.syncService.notificationTitle$.subscribe((data) => {
			this.notificationTitle = data;
		});

		this.syncService.notificationSubtitle$.subscribe((data) => {
			this.notificationSubtitle = data;
		});

		this.syncService.notifySuccess$.subscribe((data) => {
			this.showSuccessNotification = data;
		});

		this.syncService.notifyAnalyzing$.subscribe((data) => {
			this.showAnalyzingNotification = data;
		});

		this.syncService.notifyError$.subscribe((data) => {
			this.showErrorNotification = data;
		});

		this.syncService.notifyValueNotFound$.subscribe((data) => {
			this.showValueNotFoundNotification = data;
		});

		this.syncService.dealPendingDeletion$.subscribe((deal) => {
			this.dealToDelete = deal;
		});

		this.syncService.dealDeletionModalOpen$.subscribe((isOpen) => {
			this.deleteDealModalOpen = isOpen;
		});

		this.syncService.showSpinner$.subscribe((showSpinner) => {
			this.showSpinner = showSpinner;
		});

		// document.addEventListener('wheel', function(event) {
		// 	if (event.ctrlKey || event.metaKey) {
		// 		event.preventDefault();  // Prevent zooming
		// 	}
		// }, { passive: false });

		this.syncService.authStatus$.subscribe((data) => {
			this.authStatus = data;
		});

		this.syncService.page$.subscribe((data) => {
			this.page = data;
		});

		this.syncService.userId$.subscribe((data) => {
			this.dealsDocRef = data;
		});

		this.syncService.theme$.subscribe((data) => {
			this.theme = data;
		});

		this.syncService.userData$.subscribe((data) => {
			this.userData = data;
			if (this.userData) {
				// @ts-ignore
				if (this.userData['Deals'] && this.userData['Deals'].length > 0) {
					// @ts-ignore
					this.deals = this.userData['Deals'];
					this.selectedDealName = this.deals[0]['Deal Name'];
					if (this.deals.length > 0) {
						// @ts-ignore
						this.displayFiles = this.deals.map(deal => Object.values(deal)).flat().sort((a, b) => b['Timestamp'] - a['Timestamp']);
						// @ts-ignore
						if (this.userData['Selected File']) {
							// @ts-ignore
							this.selectedFileName = this.userData['Selected File'];
						}
					}
				} else {
					this.deals = [];
					this.selectedDealName = null;
					this.selectedFileName = null;
				}
				this.displayDeals = this.deals;
				this.displayFiles = this.deals.map(deal => deal['Files']).flat().sort((a, b) => b['Timestamp'] - a['Timestamp']);
				// @ts-ignore
				if (this.userData['Selected File']) {
					// @ts-ignore
					this.selectedFileName = this.userData['Selected File'];
				} else {
					this.selectedFileName = 0;
				}
				if (this.selectedFileName) {
					this.setPdfSrc(Object.values(this.selectedFileName)[0]);
				}

			} else {

				this.deals = [];
				this.displayDeals = [];
				this.displayFiles = [];

				this.page = 'funds';
				// this.theme = 'g100';
				// this.renderer.addClass(this.document.body, this.theme);

				this.selectedFileName = null;
				this.selectedDealName = null;

				// this.afStore.collection('Deals').add({
				// 	Email: this.email,
				// 	Deals: {},
				// 	Theme: this.theme,
				// 	Page: 'Deals',
				// 	'Selected Deal': null,
				// 	'Selected File': null
				// }).then(docRef => {
				// 	this.dealsDocRef = docRef.id;
				// });

				return;
			}
		});
		this.httpService.wakeUpServer();
	}

	// @HostListener('window:wheel', ['$event'])
	// onWheel(event: WheelEvent) {
	// 	event.preventDefault();
	// 	if ((event as WheelEvent).ctrlKey || (event as WheelEvent).metaKey) {
	// 		const container = this.el.nativeElement.querySelector('#scrollable-container');
	// 		const isInsideScrollableContainer = container.contains(event.target);
	// 		if (isInsideScrollableContainer) {
	// 			this.setZoomOrigin(event, container);
	// 			if (event.ctrlKey || event.metaKey) {
	// 				if (event.deltaY < 0) {
	// 					this.zoomIn();
	// 				} else {
	// 					this.zoomOut();
	// 				}
	// 			}
	// 		}
	// 	}
	// }
	//
	// setZoomOrigin(event: WheelEvent, container: HTMLElement) {
	// 	const rect = container.getBoundingClientRect();
	// 	const scrollLeft = container.scrollLeft;
	// 	const scrollTop = container.scrollTop;
	// 	const containerX = event.clientX - rect.left;
	// 	const containerY = event.clientY - rect.top;
	// 	const cursorX = scrollLeft + containerX;
	// 	const cursorY = scrollTop + containerY;
	// 	this.zoomOriginX = cursorX;
	// 	this.zoomOriginY = cursorY;
	//
	// 	if (event.deltaX !== 0) {
	// 		event.preventDefault();
	// 		container.scrollLeft += event.deltaX; // Handle horizontal scroll within the container
	// 	}
	// }
	//
	// zoomIn() {
	// 	this.zoomLevel = this.zoomLevel + 0.1;
	// }
	// zoomOut() {
	// 	this.zoomLevel = Math.max(this.zoomLevel - 0.1, 1);
	// }

	updateAuthStatus(status: string) {
		this.authStatus = status;
		this.syncService.updateAuthStatus(status);
	}

	onClickAvatar() {
		this.rightSideOpen = !this.rightSideOpen;
	}

	updateTheme() {
		this.renderer.removeClass(this.document.body, this.theme);
		switch (this.theme) {
			case 'white':
				this.theme = 'g100';
				break;
			case 'g100':
				this.theme = 'white';
				break;
			default:
				this.theme = 'g100';
		}
		this.renderer.addClass(this.document.body, this.theme);
		this.syncService.updateTheme(this.theme);
	}

	logout() {
		this.rightSideOpen = false;
		this.updateAuthStatus('unauthenticated');
		this.syncService.updatePage('login');
	}

	setPdfSrc(url: unknown) {
		this.pdfSrc = url + '#toolbar=0&#view=FitH';
		this.safePdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfSrc);
	}

	resetDisplayList() {
		this.displayDeals = this.deals;
		this.displayFiles = this.deals.map(deal => deal['Files']).flat().sort((a, b) => b['Timestamp'] - a['Timestamp']);
	}

	navigateToPage(page: string) {
		this.page = page;
		this.resetDisplayList();
		this.selectedFiles = [];
		this.hoveringOverItem = '';
		this.syncService.updatePage(this.page);
		this.syncService.updateCurrentDeal('');
	}

	@HostListener('document:click', ['$event'])
	clickOutside(event: Event) {
		// @ts-ignore
		if (this.rightSideOpen && this.panel.nativeElement && !this.panel.nativeElement.contains(event.target)) {
			this.rightSideOpen = false;
		}
	}
}
